import { LIGHT_TYPES, Light } from "@/typings/Lights";

/**
 * Keep in mind that each light will be attached to the camera.
 * In consequence their position is relative to the camera position.
 */
const lights: Light[] = [
    {
        type: LIGHT_TYPES.AMBIENT,
        intensity: 0.25,
        color: 0xffffff
    },
    {
        type: LIGHT_TYPES.DIRECTIONAL,
        intensity: 1.2,
        color: 0xffffff,
        position: {
            x: 0.5,
            y: -2,
            z: 0.866
        }
    }
];

export default lights;
